import { Phone, ClipboardList } from "lucide-react";
import { Link } from "react-router-dom";
import { BUSINESS } from "../lib/constants";

export const MobileActionBar = () => (
  <div
    data-testid="mobile-action-bar"
    className="fixed bottom-0 inset-x-0 z-50 md:hidden grid grid-cols-2 border-t border-white/20 shadow-[0_-8px_30px_rgba(19,28,26,0.18)]"
  >
    <a
      href={BUSINESS.phoneHref}
      data-testid="mobile-bar-call-button"
      className="inline-flex items-center justify-center gap-2 bg-brand-dark text-white font-semibold text-sm py-4"
      aria-label={`Call Kay's Carpet Cleaning on ${BUSINESS.phoneDisplay}`}
    >
      <Phone size={17} />
      Call Now
    </a>
    <Link
      to="/get-estimate"
      data-testid="mobile-bar-estimate-button"
      className="inline-flex items-center justify-center gap-2 bg-brand text-white font-semibold text-sm py-4"
    >
      <ClipboardList size={17} />
      Get Estimate
    </Link>
  </div>
);
